<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>THE SAMSON SYNDROME </title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="ct" id="page9"><a href="#/contents#aa_0" id="bb_0"><b>FOREWORD</b></a><br/><br/><br/></p>
<p class="tx1" id="p0009-02-1">THERE WAS NOTHING SPECIAL ABOUT THE PACKAGE. IT WAS a plain manila envelope stuffed with about 250 sheets of paper. The top sheet was a cover letter asking me to read the manuscript of a new book called <i>The Samson Syndrome</i> and consider writing a blurb for the cover. The author’s name was Mark Atteberry. I didn’t know him but was struck by the fact that he pastors a church here in the Orlando area. It was 5:00 <span class="small">P.M</span>. I had a few minutes. I decided to read a few pages and then head for home.</p>
<p class="tx" id="p0009-03-3">The next thing I knew, my phone was ringing. It was my wife, Ruth, asking when I was coming home for dinner. I looked at the clock and was stunned to realize that it was 7:20. For more than two hours I had been spellbound by this amazing book.</p>
<p class="tx" id="p0009-03-4">Why?</p>
<p class="tx" id="p0009-03-5">For one thing, it’s so well written. It has that perfect balance of depth and warmth that every writer strives for. And it’s loaded with wonderful stories that are both touching and humorous. I <a id="page10">felt as if I was reading Swindoll or Lucado. I kept thinking, who is this Mark Atteberry guy and where has he been?</a></p><a id="page10">
<p class="tx" id="p0010-02-2">But there was something else. As I turned page after page I kept getting the feeling that this man had been reading my mail! Again and again I saw myself reflected in his words. They touched me deeply. They convicted me. They led me to some important, life-changing truths.</p>
<p class="tx" id="p0010-02-3">For some reason, Samson is one Bible character who hasn’t gotten much attention over the years. After reading <i>The Samson Syndrome</i>, I realize what a tragedy that is. As Mark Atteberry shows us, Samson has a lot to say to the strong men of any generation.</p>
<p class="tx" id="p0010-02-4">I have always believed that the true measure of any book is changed lives. On that basis, this book is destined for greatness. It’s going to change many lives, and one of them could be yours. I encourage you to read it, enjoy it, and spread the word.</p>
<p class="tx" id="p0010-02-7">Oh, and one more thing: I predict you won’t be able to put this book down, so don’t start reading right before dinner.<br/><br/></p>
<p class="txr3" id="p0010-03-9">—PAT WILLIAMS </p>
<p class="txr3" id="p0010-P-1">SR. VICE PRESIDENT, ORLANDO MAGIC </p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter2.vue?042b6b10